import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {AmChart, AmChartsService} from '@amcharts/amcharts3-angular';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import * as am4maps from '@amcharts/amcharts4/maps';
import am4geodata_worldLow from '@amcharts/amcharts4-geodata/worldLow';

am4core.useTheme(am4themes_animated);

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    providers: [AmChartsService]
})

export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {

    private chart: AmChart;
    private token = localStorage.getItem('token');

    constructor(private _amCharts: AmChartsService) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.generalSales();
        this.firmAutomatsCount();
        this.mapChart();
    }

    ngOnDestroy() {
        if (this.chart) {
            this._amCharts.destroyChart(this.chart);
        }
    }

/////////////// Chart 1
    generalSales() {
        const array: any = [];
        for (let _i = 0; _i < 6; _i++) {
            const data = {
                'day': _i + 1,
                'count': 100 * _i,
                'color': '#a3a1fb'
            };
            array.push(data);
        }

        this.chart = this._amCharts.makeChart('generalSales', {
            'type': 'serial',
            'theme': 'light',
            'dataProvider': array,

            'marginRight': 0,

            'startDuration': 1,
            'categoryAxis': {
                'gridAlpha': 0
            },
            'graphs': [{
                'balloonText': '[[category]]. Gün: [[value]] Ürün',
                'fillColorsField': 'color',
                'fillAlphas': 0.9,
                'lineAlpha': 0.2,
                'type': 'column',
                'valueField': 'count',
                'columnWidth': 0.3,
                'cornerRadiusTop': 3
            }],
            'chartCursor': {
                'categoryBalloonEnabled': false,
                'cursorAlpha': 0,
                'zoomable': false
            },
            'categoryField': 'day',
            'export': {
                'enabled': false
            }
        });
    }

    ////////////////// Chart 2
    firmAutomatsCount() {
        const firmAutomatsChart = am4core.create('firmAutomatsCount', am4charts.XYChart);


// Add data
        firmAutomatsChart.data = [{
            'week': 'week1',
            'europe': 2.5,
            'namerica': 2.5,
            'asia': 2.1,
        }, {
            'week': 'week2',
            'europe': 2.6,
            'namerica': 2.7,
            'asia': 2.2,
        }, {
            'week': 'week3',
            'europe': 2.8,
            'namerica': 2.9,
            'asia': 2.4,
        }];

// Create axes
        const categoryAxis = firmAutomatsChart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = 'week';
        categoryAxis.renderer.grid.template.location = 0;


        const valueAxis = firmAutomatsChart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.inside = true;
        valueAxis.renderer.labels.template.disabled = true;
        valueAxis.min = 0;

// Create series
        function createSeries(field, name) {

            // Set up series
            const series = firmAutomatsChart.series.push(new am4charts.ColumnSeries());
            series.name = name;
            series.dataFields.valueY = field;
            series.dataFields.categoryX = 'week';
            series.sequencedInterpolation = true;

            // Make it stacked
            series.stacked = true;

            // Configure columns
            series.columns.template.width = am4core.percent(60);
            series.columns.template.tooltipText = '[bold]{name}[/]\n[font-size:14px]{categoryX}: {valueY}';

            // Add label
            const labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.label.text = '{valueY}';
            labelBullet.locationY = 0.5;

            return series;
        }

        createSeries('europe', 'Sıcak');
        createSeries('namerica', 'Snack');
        createSeries('asia', 'Karışık');


        firmAutomatsChart.legend = new am4charts.Legend();
        firmAutomatsChart.legend.position = 'top';
        firmAutomatsChart.legend.contentAlign = 'center';
        firmAutomatsChart.legend.useDefaultMarker = false;
        /*const marker = firmAutomatsChart.legend.markers.template.children.getIndex(0);
        marker.cornerRadius(12, 12, 12, 12);*/
    }

////////////////// Chart 3
    mapChart() {
        const map = am4core.create('payVend', am4maps.MapChart);
        map.geodata = am4geodata_worldLow;
        map.projection = new am4maps.projections.Miller();
        const polygonSeries = new am4maps.MapPolygonSeries();
        polygonSeries.useGeodata = true;
        map.series.push(polygonSeries);


        const polygonTemplate = polygonSeries.mapPolygons.template;


        polygonSeries.data = [{
            'id': 'US',
            'name': 'United States',
            'value': 100,
            'fill': am4core.color('#F05C5C')
        }, {
            'id': 'FR',
            'name': 'France',
            'value': 50,
            'fill': am4core.color('#5C5CFF')
        }];
        polygonTemplate.propertyFields.fill = 'fill';
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/dashboard/dashboard.component.ts